import React, { useEffect, useState } from "react";
import { usePlatformAuth } from "context/PlatformAuthContext";
import { platformApiService } from "services/platformApi";
import { useNavigate } from "react-router-dom";

const PlatformPlugins: React.FC = () => {
 const { isAuthenticated } = usePlatformAuth();
 const navigate = useNavigate();
 const [plugins, setPlugins] = useState<any[]>([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (!isAuthenticated) {
   navigate("/platform/login", { replace: true });
   return;
  }

  fetchPlugins();
 }, [isAuthenticated, navigate]);

 const fetchPlugins = async () => {
  try {
   const response = await platformApiService.getPlugins();
   setPlugins(response.data.plugins || []);
  } catch (error) {
   console.error("Error fetching plugins:", error);
  } finally {
   setLoading(false);
  }
 };

 if (loading) {
  return <div className="p-8">Loading plugins...</div>;
 }

 return (
  <div className="p-8">
   <div className="mb-6">
    <h1 className="text-3xl font-bold">Plugins</h1>
    <p className="text-gray-600 mt-2">
     Plugins are managed in the codebase. You can edit pricing and metadata here.
    </p>
   </div>
   <div className="bg-white shadow overflow-hidden">
    <table className="min-w-full divide-y divide-gray-200">
     <thead className="bg-gray-50">
      <tr>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        ID
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Name
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Category
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Price
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Status
       </th>
       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
        Actions
       </th>
      </tr>
     </thead>
     <tbody className="bg-white divide-y divide-gray-200">
      {plugins.map((plugin) => (
       <tr key={plugin._id} className="hover:bg-gray-50">
        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
         {plugin.id}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
         {plugin.name}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
         {plugin.category}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
         ${plugin.price}/{plugin.billingCycle === "yearly" ? "yr" : "mo"}
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
         <span
          className={`px-2 inline-flex text-xs leading-5 font-semibold ${
           plugin.isActive
            ? "bg-green-100 text-green-800"
            : "bg-red-100 text-red-800"
          }`}
         >
          {plugin.isActive ? "Active" : "Inactive"}
         </span>
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
         <button
          onClick={() => navigate(`/platform/plugins/${plugin._id || plugin.id}`)}
          className="text-indigo-600 hover:text-indigo-900"
         >
          Edit
         </button>
        </td>
       </tr>
      ))}
     </tbody>
    </table>
   </div>
  </div>
 );
};

export default PlatformPlugins;

